$(document).ready(function() {
  $('.logo-slider').slick({
    slidesToShow: 4,
    infinite: true,
    arrows: false,
    dots: true, // Show navigation dots
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });

 (function chevronDownloop() {
   
    $('#shopify-section-template--18101565423883__d2296b1d-fb76-4d47-b846-47f4db1bc504 .gradient img').animate({'top': '30'}, {
        duration: 1000,
        complete: function() {
            $( '#shopify-section-template--18101565423883__d2296b1d-fb76-4d47-b846-47f4db1bc504 .gradient img').animate({'top': '0'}, {
                duration: 1000, 
                complete: chevronDownloop});
        }});
})(); 

// Accordion
$(function() {
	// (Optional) Active an item if it has the class "is-active"	
	// $(".accordion > .accordion-item.is-active").children(".accordion-panel").slideUp();
	
	$(".accordion  > .accordion-item ").click(function() {
		//Cancel the siblings
		$(this).siblings(".accordion-item").addClass("is-active").children(".accordion-panel").slideUp();
		// Toggle the item
		$(this).toggleClass("is-active").children(".accordion-panel").slideToggle("ease-out");
     
      // $(this).parent(".accordion-item").removeClass("is-active").children(".accordion-panel").slideUp();
      // $(this).parent(".accordion-item").toggleClass("is-active").children(".accordion-panel").slideToggle();
      //   console.log('hi');
	});
 
});

});


